import {
	parseWarehouseInboundMessage,
	WarehouseOpenRecordMessage,
	WarehouseOutboundMessage,
	WarehouseSetModeMessage,
	WarehouseSetTabMessage,
} from './host-bridge.messages';
import { HostBridgeFactory } from './quickbase-host-bridge';

export const createQuickbaseHostBridge: HostBridgeFactory = ({ expectedOrigin, handlers }) => {
	let iframe: HTMLIFrameElement | null = null;
	let ready = false;

	const onMessage = (event: MessageEvent) => {
		if (event.origin !== expectedOrigin) return;
		if (iframe === null || iframe.contentWindow === null || event.source !== iframe.contentWindow) return;

		const message = parseWarehouseInboundMessage(event.data);
		if (message === null) return;

		if (message.type === 'warehouse:mui-ready') {
			ready = true;
			handlers.onReady();
			return;
		}
		handlers.onNavigated(message);
	};

	return {
		expectedOrigin,

		attach(element) {
			iframe = element;
			window.addEventListener('message', onMessage);
			return () => {
				window.removeEventListener('message', onMessage);
				if (iframe === element) iframe = null;
			};
		},

		isReady() {
			return ready;
		},

		setMode(mode) {
			const message: WarehouseSetModeMessage = { type: 'warehouse:set-mode', mode };
			return post(message);
		},

		openRecord({ chain, mode }) {
			const root = chain[0] ?? null;
			const message: WarehouseOpenRecordMessage = {
				type: 'warehouse:open-record',
				as: 'modal',
				recordId: root === null ? null : root.rid,
				...(root !== null && root.tab !== null ? { recordTab: root.tab } : {}),
				...(mode !== undefined && mode !== null ? { mode } : {}),
				...(chain.length > 0
					? {
							chain: chain.map((entry) => ({
								recordId: entry.rid,
								...(entry.segment !== null ? { segment: entry.segment } : {}),
								...(entry.tab !== null ? { tab: entry.tab } : {}),
							})),
						}
					: {}),
			};
			return post(message);
		},

		setTab(tab) {
			const message: WarehouseSetTabMessage = { type: 'warehouse:set-tab', tab };
			return post(message);
		},
	};

	function post(message: WarehouseOutboundMessage): boolean {
		if (!ready || iframe === null || iframe.contentWindow === null) return false;
		iframe.contentWindow.postMessage(message, expectedOrigin);
		return true;
	}
};
